import { Box, ClickAwayListener, Popper, useTheme } from '@mui/material'
import React from 'react'
import { useSocketsContext } from '../../../contexts/sockets.context'
import { useParams } from 'react-router-dom'
import { useOnlineSessionsSocketStore } from '../../../store/onlinesessionsocket.store'

const emojis = ["😀", "😂", "😍", "👍", "🎉", "👏"]

const ReactionsBar = ( { open, handleClose, anchorEl, containerRef } ) => {

    const { palette } = useTheme()
    const { meeting_id } = useParams()

    // const { socket, emitEvent } = useSocketsContext()
    const OnlineSessionSocketStore = useOnlineSessionsSocketStore()

    const sendReaction = emoji => {
        OnlineSessionSocketStore.emit( "reactions:send", { emoji, room_id: meeting_id } )
    }

    return (
        <Popper container={containerRef ? containerRef.current : null} sx={{ zIndex: 2000 }} anchorEl={anchorEl} open={open}>
            <ClickAwayListener onClickAway={handleClose} >
                <Box sx={{ userSelect: "none" }} marginBottom="10px" borderRadius="20px" padding="5px 10px" bgcolor={palette.grey[800]} display="flex" gap="5px">
                    {emojis.map( ( emoji, index ) => (
                        <Box
                            key={index}
                            sx={{ fontSize: "24px", cursor: "pointer" }}
                            onClick={() => sendReaction( emoji )}
                        >
                            {emoji}
                        </Box>
                    ) )}
                </Box>
            </ClickAwayListener>
        </Popper>
    )
}

export default ReactionsBar
